import { QueryClient } from '@tanstack/react-query';
import withLazyLoading from '../../hoc/withLazyLoading';
import LogbookTemplates from '../../pages/logBooks/components/LogbookTemplates';
import { logbookTemplateLoader } from '../../pages/logBooks/hooks/useLogbookTemplateTable';
import { logbookConfigurationLoader, LogbookConfigurationPage } from '../../pages/logbookConfiguration';
import LogbookList from '../../pages/logbookConfiguration/components/LogbookList';
import { logbookListLoader } from '../../pages/logbookConfiguration/hooks/useLogbookListTable';
import { OcrDataInputPage } from '../../pages/ocrDataInput';
import { createCrumbHandle, validatePermission } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const Profile = withLazyLoading(() => import('../../pages/Profile'));
const VideoTutorial = withLazyLoading(() => import('../../pages/VideoTutorial'));
const AboutPage = withLazyLoading(() => import('../../pages/AboutPage'));
const DataCorrection = withLazyLoading(
    () => import('../../components/DataCorrection/DataCorrection')
);
const Triggers = withLazyLoading(
    () => import('../../components/Triggers/TriggerListPage/TriggerListpage')
);
const CreateEditTrigger = withLazyLoading(
    () => import('../../components/Triggers/CreateEditTrigger/CreateEditTrigger')
);
const SystemPerformance = withLazyLoading(
    () => import("../../components/SystemPerformance/components/SystemPerformanceView"),
)

const miscRoutes = (queryClient: QueryClient) => [
    {
        path: '/profile',
        element: <Profile />,
        handle: createCrumbHandle('Profile'),
    },
    {
        path: '/video-tutorial',
        element: <VideoTutorial />,
        loader: validatePermission('VideoTutorials_View_R'),
        handle: createCrumbHandle('Video Tutorials'),
    },
    {
        path: 'aboutPage',
        element: <AboutPage />,
        handle: createCrumbHandle('About'),
    },
    {
        path: '/Data-Correction',
        element: <DataCorrection />,
        loader: validatePermission('DataCorrection_Manage_WE'),
        handle: createCrumbHandle('Data Correction'),
    },
    {
        path: '/Triggers',
        handle: createCrumbHandle('Triggers'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<Triggers />),
                loader: validatePermission('Trigger_View_R'),
            },
            {
                path: 'CreateEditTrigger/:id?',
                element: withPostHogTracker(<CreateEditTrigger />),
                loader: validatePermission('Trigger_Manage_A'),
                handle: createCrumbHandle('Create/Edit Trigger'),
            },
        ]
    },
    {
        path: "/systemPerformance",
        element: <SystemPerformance />,
        handle: createCrumbHandle('System Performance')
    },
    {
        path: "/logbookTemplates",
        element: <LogbookTemplates />,
        handle: createCrumbHandle('Logbook Templates'),
        loader: logbookTemplateLoader(queryClient)
    },
    {
        path: "/logbooks/:plantId",
        handle: createCrumbHandle('Log Books'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<LogbookList />),
                loader: logbookListLoader(queryClient),
            },
            {
                path: 'logbook-configuration/add',
                element: <LogbookConfigurationPage />,
                handle: createCrumbHandle('Configure Logbook'),
            },
            {
                path: 'logbook-configuration/:logbookAssetConfigurationId',
                element: <LogbookConfigurationPage />,
                handle: createCrumbHandle('Configure Logbook'),
                loader: logbookConfigurationLoader,
            },
        ]
    },
    {
        path: 'logbook-data-input',
        element: withPostHogTracker(<OcrDataInputPage />),
        handle: createCrumbHandle('Input Logbook Data'),
    },
];

export default miscRoutes;
